import { createApp } from 'vue'
import router from './router'
import store from './store'
import App from './App.vue'
import i18n from './i18n' // 导入i18n配置
import ElementPlus from 'element-plus' // 新增：导入ElementPlus
import 'element-plus/dist/index.css' // 新增：导入ElementPlus样式

createApp(App).use(store).use(router).use(i18n).use(ElementPlus).mount('#app') // 添加i18n和ElementPlus
